import { IconProps } from '.';

export const LightningStarsIcon = ({ color = 'currentColor', className, onClick }: IconProps) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.94492 6.6748H15.6852L8.05527 16.0928V11.3252H2.31503L9.94492 1.90527V6.6748Z'
        stroke={color}
        strokeWidth='1.35'
      />
      <path
        opacity='0.45'
        d='M2.7 0C2.7 1.49117 3.90883 2.7 5.4 2.7C3.90883 2.7 2.7 3.90883 2.7 5.4C2.7 3.90883 1.49117 2.7 0 2.7C1.49117 2.7 2.7 1.49117 2.7 0Z'
        fill={color}
      />
      <path
        opacity='0.72'
        d='M15.3 12.6C15.3 14.0911 16.5088 15.3 18 15.3C16.5088 15.3 15.3 16.5088 15.3 18C15.3 16.5088 14.0912 15.3 12.6 15.3C14.0912 15.3 15.3 14.0911 15.3 12.6Z'
        fill={color}
      />
    </svg>
  );
};
